package com.schoolconnect.app.feature.imports

import androidx.compose.runtime.Composable
import androidx.compose.foundation.layout.RowScope
import androidx.compose.ui.Modifier
import androidx.compose.ui.unit.Dp
import androidx.compose.ui.unit.dp

@Composable
fun ImportsScreen(
    state: ImportsUiState,
    onEvent: (ImportsUiEvent) -> Unit,
    contextLine: String? = null,
    headerActions: @Composable RowScope.() -> Unit = {},
    contentHorizontalPadding: Dp = 18.dp,
    contentVerticalPadding: Dp = 12.dp,
    modifier: Modifier = Modifier
) {
    when (state.stage) {
        ImportWorkflowStage.ValidationSummary -> ImportsPageContent(
            state = state,
            onEvent = onEvent,
            contextLine = contextLine,
            headerActions = headerActions,
            contentHorizontalPadding = contentHorizontalPadding,
            contentVerticalPadding = contentVerticalPadding,
            modifier = modifier
        )
        ImportWorkflowStage.ReviewAndSave -> ImportsReviewPageContent(
            state = state,
            onEvent = onEvent,
            onBackToValidationSummary = { onEvent(ImportsUiEvent.BackToValidationSummaryClicked) },
            contextLine = contextLine,
            headerActions = headerActions,
            contentHorizontalPadding = contentHorizontalPadding,
            contentVerticalPadding = contentVerticalPadding,
            modifier = modifier
        )
    }
}
